var _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgileSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-9",
    cx: 249,
    cy: 346.38,
    rx: 239.65,
    ry: 137.31,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-9",
    cx: 48.46,
    cy: 381.46,
    rx: 21.03,
    ry: 12.14,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-9",
    cx: 100.72,
    cy: 417.08,
    rx: 21.03,
    ry: 12.14,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-9",
    d: "M366.94,356c-23.93-13.82-62.72-13.82-86.65,0C260,367.67,256.93,385.54,271,399.13a10,10,0,0,0-2.28.93L193.17,443.7c-3.21,1.85-3.21,4.85,0,6.71l4.73,2.73a11.94,11.94,0,0,0,11.42-.32l70.4-46.07a7.61,7.61,0,0,0,.81-.64c23.94,13.68,62.56,13.64,86.41-.13S390.86,369.77,366.94,356Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-9",
    d: "M466.18,313c19,10.68,19.15,28.32.43,39.41s-49.28,11.41-68.25.73-19.16-28.32-.42-39.4S447.22,302.29,466.18,313Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Grid--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--grid--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.42,
    y: 140.2,
    width: 242.11,
    height: 1.06,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -49.03, 98.75)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.42,
    y: 165.62,
    width: 242.11,
    height: 1.06,
    transform: "translate(-61.75 102.16) rotate(-30.04)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.42,
    y: 191.03,
    width: 242.11,
    height: 1.06,
    transform: "translate(-74.44 105.47) rotate(-30.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.42,
    y: 216.45,
    width: 242.11,
    height: 1.06,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -87.15, 108.87)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.42,
    y: 241.86,
    width: 242.11,
    height: 1.06,
    transform: "translate(-99.87 112.29) rotate(-30.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.42,
    y: 267.28,
    width: 242.11,
    height: 1.06,
    transform: "translate(-112.58 115.7) rotate(-30.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.18,
    y: 164.93,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.24,
    y: 153.92,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 142.92,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.36,
    y: 131.91,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.42,
    y: 120.91,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 109.9,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 98.9,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.6,
    y: 87.89,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.67,
    y: 76.89,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.73,
    y: 65.88,
    width: 1.06,
    height: 177.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.64,354.28a.59.59,0,0,1-.26-.07.55.55,0,0,1-.27-.46V175.93a.55.55,0,0,1,.27-.46l209.67-121a.51.51,0,0,1,.53,0,.53.53,0,0,1,.26.46V232.69a.53.53,0,0,1-.26.46L54.91,354.21A.64.64,0,0,1,54.64,354.28Zm.53-178V352.83L263.79,232.39V55.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.42,
    y: 303.66,
    width: 242.11,
    height: 1.06,
    transform: "translate(-128.25 130.1) rotate(-30.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.48,
    y: 314.66,
    width: 242.11,
    height: 1.06,
    transform: "translate(-131.19 141.1) rotate(-30.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.54,
    y: 325.67,
    width: 242.11,
    height: 1.06,
    transform: "translate(-134.14 152.13) rotate(-30.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.6,
    y: 336.67,
    width: 242.11,
    height: 1.06,
    transform: "translate(-137.09 163.14) rotate(-30.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.83,
    y: 315.23,
    width: 1.06,
    height: 110.05,
    transform: "translate(-259.97 290.23) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.89,
    y: 304.23,
    width: 1.06,
    height: 110.05,
    transform: "translate(-240.91 301.23) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.95,
    y: 293.22,
    width: 1.06,
    height: 110.05,
    transform: "translate(-221.85 312.24) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.01,
    y: 282.22,
    width: 1.06,
    height: 110.05,
    transform: "translate(-202.79 323.24) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.07,
    y: 271.21,
    width: 1.06,
    height: 110.05,
    transform: "translate(-183.73 334.25) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.13,
    y: 260.21,
    width: 1.06,
    height: 110.05,
    transform: "translate(-164.67 345.25) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.2,
    y: 249.2,
    width: 1.06,
    height: 110.05,
    transform: "translate(-145.61 356.26) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.26,
    y: 238.2,
    width: 1.06,
    height: 110.05,
    transform: "translate(-126.54 367.26) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.32,
    y: 227.19,
    width: 1.06,
    height: 110.05,
    transform: "translate(-107.48 378.26) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.38,
    y: 216.19,
    width: 1.06,
    height: 110.05,
    transform: "translate(-88.42 389.27) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.88,409.26a.48.48,0,0,1-.26-.07l-95.24-55a.53.53,0,0,1,0-.92l209.67-121a.51.51,0,0,1,.53,0l95.24,55a.54.54,0,0,1,0,.92L150.15,409.19A.54.54,0,0,1,149.88,409.26ZM55.7,353.75l94.18,54.37L358.5,287.68,264.32,233.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--charts--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107,181.59c0,11.5-6.53,24.86-14.58,29.85s-14.57-.31-14.57-11.81,6.53-24.86,14.57-29.84v22.07l13.87-16.26A23.49,23.49,0,0,1,107,181.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,172.39c-1.9-7.18-7.39-9.82-13.87-5.81v22.07Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32,163.58l8.57,11.55a27.71,27.71,0,0,1-8.57,9.27c-8,5-14.57-.3-14.57-11.8s6.52-24.86,14.57-29.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1,174.23a41.59,41.59,0,0,0,6-20.56c0-11.51-6.53-16.79-14.57-11.81v20.82Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,88V108.8L220.21,111C222.11,101.42,227.6,92,234.08,88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.67,113.34a35.3,35.3,0,0,0-.71,6.87c0,11.5,6.53,16.79,14.58,11.81s14.57-18.34,14.57-29.84-6.53-16.79-14.57-11.81V111.2Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,114.25v20.83l-8.56,22.15c-3.64-1.53-6-6.21-6-13.14C173.34,132.6,179.86,119.23,187.91,114.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.69,157.89c2.4,1,5.36.66,8.56-1.32,8.05-5,14.58-18.34,14.58-29.84s-6.53-16.79-14.58-11.81v20.82Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,239.11V232.3a.54.54,0,0,1,.25-.43L101,221.81c.14-.08.25,0,.25.14v6.8a.56.56,0,0,1-.25.44L83.83,239.25C83.69,239.33,83.58,239.27,83.58,239.11Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.32,211.68v-6.8a.56.56,0,0,1,.25-.44l17.21-10.06c.14-.08.25,0,.25.15v6.8a.56.56,0,0,1-.25.44l-17.21,10.06C131.43,211.91,131.32,211.84,131.32,211.68Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,184.26v-6.8a.56.56,0,0,1,.25-.44L196.52,167c.14-.08.25,0,.25.15v6.8a.54.54,0,0,1-.25.43l-17.21,10.07C179.17,184.49,179.06,184.42,179.06,184.26Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.8,156.84V150a.54.54,0,0,1,.25-.44l17.21-10.06c.14-.08.25,0,.25.14v6.8a.54.54,0,0,1-.25.44L227.05,157C226.91,157.06,226.8,157,226.8,156.84Z",
    style: {
      fill: "#3A447C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graph--inject-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "298.08 126.27 279.02 159.04 259.96 215.25 240.9 204.82 221.83 257.26 202.77 246.83 183.71 258.25 164.65 284.65 145.59 283.27 126.53 322.4 107.47 321.32 88.41 347.83 88.41 373.24 92.7 375.72 302.37 254.64 302.37 128.75 298.08 126.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.7 350.31 111.76 323.8 130.82 324.88 149.88 285.75 168.94 287.13 188 260.73 207.07 249.31 226.13 259.74 245.19 207.3 264.25 217.73 283.31 161.52 302.37 128.75 302.37 254.64 92.7 375.72 92.7 350.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.41 347.83 92.7 350.31 111.76 323.8 107.47 321.32 88.41 347.83",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.59 283.27 149.88 285.75 130.82 324.88 126.53 322.4 145.59 283.27",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.65 284.65 168.94 287.13 188 260.73 183.71 258.25 164.65 284.65",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.9 204.82 245.19 207.3 226.13 259.74 221.83 257.26 240.9 204.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.02 159.04 283.31 161.52 264.25 217.73 259.96 215.25 279.02 159.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,136.44a.43.43,0,0,1-.37-.68l16.29-24.58a.44.44,0,0,1,.73.49l-16.29,24.58A.44.44,0,0,1,282.21,136.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.39,192.26a.35.35,0,0,1-.14,0,.44.44,0,0,1-.28-.56l16.3-48a.44.44,0,0,1,.56-.28.44.44,0,0,1,.27.56L262.81,192A.45.45,0,0,1,262.39,192.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,195.16a.42.42,0,0,1-.21-.06l-13.25-7.24a.43.43,0,0,1-.17-.59.44.44,0,0,1,.6-.18l13.25,7.24a.44.44,0,0,1,.17.6A.45.45,0,0,1,258.85,195.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.87,235.12a.4.4,0,0,1-.15,0,.44.44,0,0,1-.27-.56l16.11-44.32a.45.45,0,0,1,.57-.27.44.44,0,0,1,.26.57l-16.11,44.32A.43.43,0,0,1,225.87,235.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.24,238A.54.54,0,0,1,222,238l-14.75-8.08a.44.44,0,0,1,.43-.77l14.75,8.07a.44.44,0,0,1,.17.6A.43.43,0,0,1,222.24,238Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.08,238.48a.42.42,0,0,1-.37-.21.44.44,0,0,1,.15-.61l13.42-8a.44.44,0,0,1,.45.76l-13.42,8A.46.46,0,0,1,189.08,238.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.69,263.13a.45.45,0,0,1-.36-.7l14.31-19.82a.44.44,0,0,1,.72.52l-14.31,19.81A.42.42,0,0,1,169.69,263.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,266.38h0l-13.88-1a.44.44,0,0,1-.41-.47.43.43,0,0,1,.47-.41l13.88,1a.44.44,0,0,1,.41.47A.45.45,0,0,1,164.6,266.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.05,300.28a.45.45,0,0,1-.19,0,.43.43,0,0,1-.2-.59l15.15-31.11a.45.45,0,0,1,.59-.2.44.44,0,0,1,.2.59L131.45,300A.44.44,0,0,1,131.05,300.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,304.17h0l-13.9-.79a.44.44,0,0,1,0-.88l13.9.79a.44.44,0,0,1,0,.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,329.75a.43.43,0,0,1-.26-.09.44.44,0,0,1-.1-.61l16.65-23.16a.46.46,0,0,1,.62-.1.45.45,0,0,1,.1.62L91.32,329.56A.45.45,0,0,1,91,329.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.9,307.35a1.85,1.85,0,0,1-1-.25,2.94,2.94,0,0,1-1.2-2.67,7.14,7.14,0,0,1,3-5.78,2.24,2.24,0,0,1,2.3-.15,2.93,2.93,0,0,1,1.19,2.67,7.15,7.15,0,0,1-3.05,5.78A2.64,2.64,0,0,1,108.9,307.35Zm2.25-8.22a2,2,0,0,0-.91.28,6.31,6.31,0,0,0-2.6,5,2.12,2.12,0,0,0,.75,1.91,1.44,1.44,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.1,2.1,0,0,0-.76-1.91A1,1,0,0,0,111.15,299.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,269.42a1.85,1.85,0,0,1-1-.25,2.93,2.93,0,0,1-1.19-2.67,7.17,7.17,0,0,1,3.05-5.79,2.27,2.27,0,0,1,2.29-.15,3,3,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3,5.79A2.68,2.68,0,0,1,147,269.42Zm2.25-8.22a1.8,1.8,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.11,2.11,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.33,6.33,0,0,0,2.6-5,2.11,2.11,0,0,0-.75-1.9A1,1,0,0,0,149.27,261.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,308.23A1.85,1.85,0,0,1,127,308a2.94,2.94,0,0,1-1.2-2.67,7.15,7.15,0,0,1,3.05-5.78,2.24,2.24,0,0,1,2.3-.15,2.93,2.93,0,0,1,1.19,2.67,7.14,7.14,0,0,1-3,5.78A2.68,2.68,0,0,1,128,308.23Zm2.25-8.22a1.87,1.87,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.12,2.12,0,0,0,.75,1.91,1.44,1.44,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.12,2.12,0,0,0-.75-1.91A1.07,1.07,0,0,0,130.21,300Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08,270.45a1.85,1.85,0,0,1-1-.25,2.93,2.93,0,0,1-1.19-2.67,7.14,7.14,0,0,1,3.05-5.78,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.15,7.15,0,0,1-3,5.78A2.68,2.68,0,0,1,166.08,270.45Zm2.25-8.22a1.91,1.91,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.1,2.1,0,0,0,.76,1.91,1.42,1.42,0,0,0,1.41-.15,6.31,6.31,0,0,0,2.6-5,2.12,2.12,0,0,0-.75-1.91A1.07,1.07,0,0,0,168.33,262.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14,243.86a1.84,1.84,0,0,1-.94-.25,2.92,2.92,0,0,1-1.2-2.67,7.15,7.15,0,0,1,3.05-5.78,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.14,7.14,0,0,1-3,5.78A2.68,2.68,0,0,1,185.14,243.86Zm2.25-8.22a1.91,1.91,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.13,2.13,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.13,2.13,0,0,0-.76-1.91A1.07,1.07,0,0,0,187.39,235.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,232.86a1.84,1.84,0,0,1-.94-.25,2.94,2.94,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3.05-5.79,2.24,2.24,0,0,1,2.29-.15,3,3,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3,5.79A2.68,2.68,0,0,1,204.2,232.86Zm2.25-8.23a1.81,1.81,0,0,0-.9.29,6.29,6.29,0,0,0-2.61,5,2.11,2.11,0,0,0,.76,1.9,1.41,1.41,0,0,0,1.41-.14,6.31,6.31,0,0,0,2.61-5,2.11,2.11,0,0,0-.76-1.9A1,1,0,0,0,206.45,224.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,243.29a1.85,1.85,0,0,1-1-.25,2.94,2.94,0,0,1-1.2-2.67,7.14,7.14,0,0,1,3-5.78,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.15,7.15,0,0,1-3,5.78A2.67,2.67,0,0,1,223.27,243.29Zm2.24-8.22a1.91,1.91,0,0,0-.9.28,6.42,6.42,0,0,0-2.61,5,2.13,2.13,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.13,2.13,0,0,0-.76-1.91A1,1,0,0,0,225.51,235.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.33,190.85a1.85,1.85,0,0,1-1-.25,2.94,2.94,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3-5.79,2.24,2.24,0,0,1,2.29-.14,2.92,2.92,0,0,1,1.2,2.66,7.17,7.17,0,0,1-3.05,5.79A2.67,2.67,0,0,1,242.33,190.85Zm2.24-8.22a1.84,1.84,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.14,2.14,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.31,6.31,0,0,0,2.61-5,2.12,2.12,0,0,0-.76-1.9A.93.93,0,0,0,244.57,182.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,200.45a2,2,0,0,1-.95-.25,2.94,2.94,0,0,1-1.19-2.67,7.17,7.17,0,0,1,3.05-5.79,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3,5.79A2.78,2.78,0,0,1,259.88,200.45Zm2.25-8.23a1.91,1.91,0,0,0-.9.28,6.31,6.31,0,0,0-2.61,5,2.11,2.11,0,0,0,.76,1.9,1.42,1.42,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.14,2.14,0,0,0-.76-1.91A1.07,1.07,0,0,0,262.13,192.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,144.23A1.84,1.84,0,0,1,278,144a2.94,2.94,0,0,1-1.2-2.67,7.15,7.15,0,0,1,3.05-5.78,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.14,7.14,0,0,1-3,5.78A2.68,2.68,0,0,1,278.94,144.23Zm2.25-8.22a1.91,1.91,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.13,2.13,0,0,0,.76,1.91,1.41,1.41,0,0,0,1.41-.15,6.42,6.42,0,0,0,2.61-5,2.13,2.13,0,0,0-.76-1.91A1,1,0,0,0,281.19,136Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.51,112.3a2,2,0,0,1-.95-.25,2.94,2.94,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3.05-5.79,2.26,2.26,0,0,1,2.3-.15,2.94,2.94,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3.05,5.79A2.78,2.78,0,0,1,299.51,112.3Zm2.25-8.23a1.87,1.87,0,0,0-.9.28,6.32,6.32,0,0,0-2.61,5,2.1,2.1,0,0,0,.75,1.9,1.43,1.43,0,0,0,1.41-.14,6.32,6.32,0,0,0,2.61-5,2.1,2.1,0,0,0-.75-1.9A1,1,0,0,0,301.76,104.07Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graph--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.14,134.75a.46.46,0,0,1-.2-.05.44.44,0,0,1-.19-.6l15.06-28.77a.44.44,0,0,1,.59-.19.44.44,0,0,1,.19.6l-15.06,28.77A.44.44,0,0,1,319.14,134.75Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.34,196.3a.32.32,0,0,1-.13,0,.44.44,0,0,1-.29-.55l16.53-53.63a.45.45,0,0,1,.56-.29.44.44,0,0,1,.29.55L299.76,196A.43.43,0,0,1,299.34,196.3Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,198.89a.46.46,0,0,1-.27-.09l-15.06-11.38a.44.44,0,0,1,.53-.71l15.06,11.39a.44.44,0,0,1,.09.62A.46.46,0,0,1,296.08,198.89Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.44,234.21l-.15,0a.45.45,0,0,1-.27-.57l16.1-44.16a.44.44,0,0,1,.83.31l-16.1,44.15A.43.43,0,0,1,261.44,234.21Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.56,237.67l-.11,0L243.18,234a.46.46,0,0,1-.32-.54.44.44,0,0,1,.54-.32l14.27,3.64a.44.44,0,0,1,.32.53A.45.45,0,0,1,257.56,237.67Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,283.82l-.15,0a.44.44,0,0,1-.27-.56l16.09-46.33a.45.45,0,0,1,.57-.27.44.44,0,0,1,.27.56l-16.1,46.33A.44.44,0,0,1,223.39,283.82Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.78,286.46a.48.48,0,0,1-.29-.11l-15.2-13.56a.44.44,0,1,1,.58-.66l15.21,13.56a.43.43,0,0,1,0,.62A.41.41,0,0,1,219.78,286.46Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,270.66h-.11L186,267a.44.44,0,1,1,.21-.85l14.16,3.6a.44.44,0,0,1-.11.87Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.41,307.13a.38.38,0,0,1-.17,0,.43.43,0,0,1-.23-.57l15.56-36.61a.44.44,0,1,1,.81.34l-15.56,36.61A.43.43,0,0,1,166.41,307.13Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.27,313.5a.44.44,0,0,1-.43-.39.42.42,0,0,1,.37-.49l13.66-1.85a.44.44,0,0,1,.12.87l-13.66,1.85Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.53,350.28a.54.54,0,0,1-.21,0,.44.44,0,0,1-.18-.6L143.2,317a.44.44,0,1,1,.78.4L126.92,350A.44.44,0,0,1,126.53,350.28Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,318a1.84,1.84,0,0,1-.94-.25,2.94,2.94,0,0,1-1.2-2.67,7.14,7.14,0,0,1,3.05-5.78,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.15,7.15,0,0,1-3.05,5.78A2.68,2.68,0,0,1,144.46,318Zm2.25-8.22a1.91,1.91,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5A2.13,2.13,0,0,0,144,317a1.44,1.44,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.13,2.13,0,0,0-.76-1.91A1,1,0,0,0,146.71,309.75Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59,270.67a1.85,1.85,0,0,1-1-.25,2.94,2.94,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3.05-5.79,2.27,2.27,0,0,1,2.29-.15,2.93,2.93,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3,5.79A2.67,2.67,0,0,1,182.59,270.67Zm2.24-8.23a1.84,1.84,0,0,0-.9.29,6.29,6.29,0,0,0-2.61,5,2.14,2.14,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.31,6.31,0,0,0,2.61-5,2.11,2.11,0,0,0-.76-1.9A.94.94,0,0,0,184.83,262.44Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,315.19a1.85,1.85,0,0,1-.95-.25,2.94,2.94,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3.05-5.79,2.24,2.24,0,0,1,2.29-.15,3,3,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3,5.79A2.67,2.67,0,0,1,163.53,315.19Zm2.24-8.23a1.81,1.81,0,0,0-.9.29,6.39,6.39,0,0,0-2.61,5,2.14,2.14,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.42,6.42,0,0,0,2.61-5,2.11,2.11,0,0,0-.76-1.9A1,1,0,0,0,165.77,307Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.65,275.18a1.85,1.85,0,0,1-1-.25,2.94,2.94,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3.05-5.79,2.24,2.24,0,0,1,2.29-.15A2.92,2.92,0,0,1,206,269a7.17,7.17,0,0,1-3,5.79A2.75,2.75,0,0,1,201.65,275.18ZM203.9,267a2,2,0,0,0-.91.28,6.41,6.41,0,0,0-2.6,5,2.1,2.1,0,0,0,.75,1.9,1.44,1.44,0,0,0,1.41-.14,6.32,6.32,0,0,0,2.61-5,2.08,2.08,0,0,0-.76-1.9A.93.93,0,0,0,203.9,267Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.71,292a1.85,1.85,0,0,1-1-.25,2.94,2.94,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3.05-5.79,2.26,2.26,0,0,1,2.3-.15,2.94,2.94,0,0,1,1.19,2.67,7.17,7.17,0,0,1-3,5.79A2.64,2.64,0,0,1,220.71,292Zm2.25-8.22a1.84,1.84,0,0,0-.91.28,6.38,6.38,0,0,0-2.6,5,2.13,2.13,0,0,0,.75,1.91,1.44,1.44,0,0,0,1.41-.15,6.31,6.31,0,0,0,2.61-5,2.09,2.09,0,0,0-.76-1.9A.91.91,0,0,0,223,283.76Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.77,237.53a1.85,1.85,0,0,1-1-.25,2.94,2.94,0,0,1-1.2-2.67,7.14,7.14,0,0,1,3-5.78,2.24,2.24,0,0,1,2.3-.15,2.94,2.94,0,0,1,1.2,2.67,7.15,7.15,0,0,1-3,5.78A2.68,2.68,0,0,1,239.77,237.53Zm2.25-8.22a1.77,1.77,0,0,0-.9.28,6.39,6.39,0,0,0-2.61,5,2.12,2.12,0,0,0,.75,1.91,1.44,1.44,0,0,0,1.41-.15,6.39,6.39,0,0,0,2.61-5,2.12,2.12,0,0,0-.75-1.91A1.07,1.07,0,0,0,242,229.31Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.83,242.39a2,2,0,0,1-.95-.25,2.94,2.94,0,0,1-1.19-2.67,7.17,7.17,0,0,1,3.05-5.79,2.24,2.24,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3.05,5.79A2.78,2.78,0,0,1,258.83,242.39Zm2.25-8.23a1.91,1.91,0,0,0-.9.28,6.31,6.31,0,0,0-2.61,5,2.08,2.08,0,0,0,.76,1.9,1.42,1.42,0,0,0,1.41-.15,6.31,6.31,0,0,0,2.6-5,2.13,2.13,0,0,0-.75-1.91A1.07,1.07,0,0,0,261.08,234.16Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.89,190.11a2,2,0,0,1-.95-.25,2.94,2.94,0,0,1-1.19-2.67,7.17,7.17,0,0,1,3.05-5.79,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3.05,5.79A2.78,2.78,0,0,1,277.89,190.11Zm2.25-8.23a1.91,1.91,0,0,0-.9.28,6.39,6.39,0,0,0-2.61,5,2.08,2.08,0,0,0,.76,1.9,1.42,1.42,0,0,0,1.41-.15,6.38,6.38,0,0,0,2.6-5,2.13,2.13,0,0,0-.75-1.91A1.07,1.07,0,0,0,280.14,181.88Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,204.52a1.94,1.94,0,0,1-.94-.25,3,3,0,0,1-1.2-2.67,7.17,7.17,0,0,1,3.05-5.79,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.17,7.17,0,0,1-3.05,5.79A2.78,2.78,0,0,1,297,204.52Zm2.25-8.23a1.91,1.91,0,0,0-.9.28,6.31,6.31,0,0,0-2.61,5,2.11,2.11,0,0,0,.76,1.9,1.41,1.41,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.14,2.14,0,0,0-.76-1.91A1,1,0,0,0,299.2,196.29Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,142.68a1.85,1.85,0,0,1-.95-.25,2.94,2.94,0,0,1-1.2-2.67,7.14,7.14,0,0,1,3.05-5.78,2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.15,7.15,0,0,1-3.05,5.78A2.67,2.67,0,0,1,316,142.68Zm2.24-8.22a1.91,1.91,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.13,2.13,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.13,2.13,0,0,0-.76-1.91A1,1,0,0,0,318.26,134.46Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.08,106.26a1.85,1.85,0,0,1-.95-.25,2.94,2.94,0,0,1-1.2-2.67A7.14,7.14,0,0,1,336,97.56a2.22,2.22,0,0,1,2.29-.15,2.94,2.94,0,0,1,1.2,2.67,7.15,7.15,0,0,1-3.05,5.78A2.67,2.67,0,0,1,335.08,106.26ZM337.32,98a1.91,1.91,0,0,0-.9.28,6.29,6.29,0,0,0-2.61,5,2.13,2.13,0,0,0,.76,1.91,1.44,1.44,0,0,0,1.41-.15,6.29,6.29,0,0,0,2.61-5,2.13,2.13,0,0,0-.76-1.91A1,1,0,0,0,337.32,98Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.2 121.71 317.14 158.13 298.27 219.34 283.31 208.03 279.02 205.55 259.96 257.83 240.9 252.98 222.19 306.81 207.07 293.33 202.77 290.85 183.71 285.99 164.65 330.83 145.59 333.42 126.53 369.84 126.53 395.25 130.82 397.73 340.5 276.68 340.5 124.19 336.2 121.71",
    style: {
      fill: "#3A447C",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.82 372.31 149.88 335.89 168.94 333.31 188 288.47 207.07 293.33 226.13 310.32 245.19 255.46 264.25 260.31 283.31 208.03 302.37 222.44 321.43 160.61 340.5 124.19 340.5 276.68 130.82 397.73 130.82 372.31",
    style: {
      fill: "#3A447C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.53 369.84 130.82 372.31 130.82 397.73 126.53 395.25 126.53 369.84",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.53 369.84 130.82 372.31 130.82 397.73 126.53 395.25 126.53 369.84",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.65 330.83 168.94 333.31 188 288.47 183.71 285.99 164.65 330.83",
    style: {
      fill: "#3A447C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.65 330.83 168.94 333.31 188 288.47 183.71 285.99 164.65 330.83",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.59 333.42 149.88 335.89 130.82 372.31 126.53 369.84 145.59 333.42",
    style: {
      fill: "#3A447C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.59 333.42 149.88 335.89 130.82 372.31 126.53 369.84 145.59 333.42",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.19 255.46 240.9 252.98 222.19 306.81 226.13 310.32 245.19 255.46",
    style: {
      fill: "#3A447C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.19 255.46 240.9 252.98 222.19 306.81 226.13 310.32 245.19 255.46",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.96 257.83 264.25 260.31 283.31 208.03 279.02 205.55 259.96 257.83",
    style: {
      fill: "#3A447C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.96 257.83 264.25 260.31 283.31 208.03 279.02 205.55 259.96 257.83",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.43 160.61 317.14 158.13 298.27 219.34 302.37 222.44 321.43 160.61",
    style: {
      fill: "#3A447C",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.43 160.61 317.14 158.13 298.27 219.34 302.37 222.44 321.43 160.61",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arrow--inject-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.76 90.55 353.47 88.08 342.74 112.86 347.03 115.34 349.18 114.1 349.18 267.21 353.47 269.69 362.06 264.74 362.06 106.67 368.5 102.95 357.76 90.55",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.5 102.95 357.76 90.55 347.03 115.34 353.47 111.62 353.47 269.69 362.06 264.74 362.06 106.67 368.5 102.95",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.74 112.86 347.03 115.34 357.76 90.55 353.47 88.08 342.74 112.86",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.18 267.21 353.47 269.69 353.47 111.62 349.18 114.1 349.18 267.21",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.47,356.53H29.57l3.92,22.7h0c.3,2,1.75,3.88,4.36,5.39,5.89,3.4,15.45,3.4,21.34,0,2.81-1.62,4.26-3.72,4.4-5.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.42,360.46c-8.23,4.74-21.57,4.74-29.8,0a15.38,15.38,0,0,1-3.94-3.16l1,6.57a14.64,14.64,0,0,0,3.69,2.92c7.84,4.53,20.54,4.53,28.38,0a14.6,14.6,0,0,0,3.68-2.93l1-6.56A15.15,15.15,0,0,1,63.42,360.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.49,379.22h0c.3,2,1.75,3.89,4.36,5.4,4.21,2.43,10.29,3.11,15.57,2.07-9.47.72-16-3.41-16.94-7.23s-2.22-18.29-2.22-18.29l1.05-4.23-.3-.41H29.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.44,351.7a8.08,8.08,0,0,1-1.27,2.95,14,14,0,0,1-4.75,4.22c-8.23,4.75-21.57,4.75-29.8,0a14,14,0,0,1-4.75-4.22,8.23,8.23,0,0,1-1.26-2.95h0c-.74-3.57,1.27-7.29,6-10,8.23-4.75,21.57-4.75,29.8,0C68.16,344.41,70.17,348.13,69.44,351.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.17,354.65a14,14,0,0,1-4.75,4.22c-8.23,4.75-21.57,4.75-29.8,0a14,14,0,0,1-4.75-4.22,8.23,8.23,0,0,1-1.26-2.95h0l.93,6.43c.43,2.58,2.35,5.1,5.79,7.08,7.84,4.52,20.54,4.52,28.38,0,3.39-2,5.31-4.44,5.77-7l0-.33.91-6.19A8.08,8.08,0,0,1,68.17,354.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94,343.1c-6.86-4-18-4-24.83,0-3.88,2.25-5.56,5.27-5.05,8.19.39,2.25,2.08,4.43,5.05,6.14,6.85,4,18,4,24.83,0,3-1.71,4.65-3.89,5-6.13C66.5,348.37,64.82,345.35,60.94,343.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,354a11.52,11.52,0,0,0,3.89,3.42c6.85,4,18,4,24.83,0A11.83,11.83,0,0,0,64.83,354c0-2.37-1.64-4.73-4.77-6.54-6.37-3.68-16.7-3.68-23.07,0C33.86,349.28,32.27,351.64,32.22,354Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flower--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8,354.65s-3.59-5.18-1.9-10.47,6.08-8.78,7.68-8.58,4.23,5.22,3.1,10.59A10.33,10.33,0,0,1,48.8,354.65Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8,354.65s-3.59-5.18-1.9-10.47,6.08-8.78,7.68-8.58,4.23,5.22,3.1,10.59A10.33,10.33,0,0,1,48.8,354.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8,354.64c-.25-9.74,5.78-19,5.78-19-1.6-.2-6,3.19-7.68,8.59C45.25,349.34,48.63,354.39,48.8,354.64Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flower--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8,354.64a6.55,6.55,0,0,0-2.16-4.75c-2.2-1.69-4.91-1.84-5.5-1.31s-.25,3.29,1.71,5.14A5.07,5.07,0,0,0,48.8,354.64Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8,354.64a6.55,6.55,0,0,0-2.16-4.75c-2.2-1.69-4.91-1.84-5.5-1.31s-.25,3.29,1.71,5.14A5.07,5.07,0,0,0,48.8,354.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8,354.64c-2.62-4-7.66-6.06-7.66-6.06.59-.53,3.3-.38,5.5,1.31A6.52,6.52,0,0,1,48.8,354.64Z",
    style: {
      opacity: 0.25
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot-with-flowerr--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.49,394.22H81.59l3.92,22.69h0c.3,2,1.75,3.89,4.36,5.39,5.89,3.41,15.45,3.41,21.34,0,2.81-1.62,4.26-3.72,4.4-5.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44,398.15c-8.23,4.75-21.57,4.75-29.8,0A15.38,15.38,0,0,1,81.7,395l1,6.57a14.66,14.66,0,0,0,3.69,2.93c7.84,4.52,20.54,4.52,28.38,0a14.62,14.62,0,0,0,3.68-2.94l1-6.55A15.33,15.33,0,0,1,115.44,398.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.51,416.92h0c.3,2,1.75,3.88,4.36,5.39,4.21,2.43,10.29,3.12,15.57,2.07-9.47.73-16-3.41-16.94-7.22s-2.22-18.29-2.22-18.29l1-4.23-.3-.41H81.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.46,389.4a8,8,0,0,1-1.27,2.94,14,14,0,0,1-4.75,4.22c-8.23,4.75-21.57,4.75-29.8,0a14,14,0,0,1-4.75-4.22,8.11,8.11,0,0,1-1.26-2.94h0c-.74-3.57,1.27-7.3,6-10,8.23-4.76,21.57-4.76,29.8,0C120.18,382.1,122.19,385.83,121.46,389.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19,392.34a14,14,0,0,1-4.75,4.22c-8.23,4.75-21.57,4.75-29.8,0a14,14,0,0,1-4.75-4.22,8.11,8.11,0,0,1-1.26-2.94h0l.93,6.42c.43,2.58,2.35,5.1,5.79,7.08,7.84,4.52,20.54,4.52,28.38,0,3.39-1.95,5.31-4.44,5.77-7l0-.33.91-6.18A8,8,0,0,1,120.19,392.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,380.8c-6.86-4-18-4-24.83,0-3.88,2.24-5.56,5.26-5,8.19.39,2.24,2.08,4.42,5,6.14,6.85,4,18,4,24.83,0,3-1.72,4.65-3.9,5-6.14C118.52,386.06,116.84,383,113,380.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.24,391.7a11.65,11.65,0,0,0,3.89,3.43c6.85,4,18,4,24.83,0a11.85,11.85,0,0,0,3.89-3.43c0-2.37-1.64-4.73-4.77-6.54-6.38-3.68-16.7-3.68-23.07,0C85.88,387,84.29,389.33,84.24,391.7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flower--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.54,379.44s.75-6.61,5.78-9.63,11-2.75,12.08-1.47-.27,7.09-4.92,10.57A10.88,10.88,0,0,1,100.54,379.44Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,379.44c6.58-7.91,17.86-11.11,17.86-11.11-1.13-1.27-7-1.61-12.08,1.48C101.41,372.76,100.58,379.12,100.54,379.44Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.92,391.91a2.5,2.5,0,0,1-1.14-.65,2.88,2.88,0,0,1-.72-.87,6.46,6.46,0,0,1-.72-1.91,37.69,37.69,0,0,1-.72-3.85,48.34,48.34,0,0,1-.39-7.69,59.52,59.52,0,0,1,.78-7.66,54.9,54.9,0,0,1,1.91-7.47,85.52,85.52,0,0,0,3.77-14.25,37.65,37.65,0,0,0-.22-14.69l.2-.06a30.16,30.16,0,0,1,1.73,7.35,43,43,0,0,1,.06,7.61,79.83,79.83,0,0,1-2.86,14.88A55.1,55.1,0,0,0,101.72,377a69.77,69.77,0,0,0,.29,7.24c.11,1.2.26,2.38.47,3.54a9.91,9.91,0,0,1,.27,1.69,6.63,6.63,0,0,1-.21,1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flower--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.2,378.41s.78-8-4.4-12.84-12.27-6-13.92-4.78-2.07,10,2.55,15.32S96,380.81,99.2,378.41Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,378.4c-5.79-11-18.32-17.62-18.32-17.62,1.65-1.22,8.63-.15,13.91,4.79C99.85,370.28,99.24,378,99.2,378.4Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104,330.42a13.22,13.22,0,0,0,4.46-2.83c2.29-2.13,4.73-7,5.25-11.66s-1.18-10.43-2-11.28a3,3,0,0,0-2.27-.63,5.42,5.42,0,0,0-3.1-1.71c-1.94-.3-3.29-.1-4.37,1.1s-1.41,1.73-2.34,2.71-2.31,4.24-2.29,8.25C97.38,318.09,99.2,326,104,330.42Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,313.6c-.07-.13-.29,0-.32.09a11,11,0,0,0,0,2.69c0,.9-.08,1.81-.15,2.7-.18,2.33-1.35,4-2.33,6.08-.21.45-.54,1.12-.87,1.89-.1-2.31.68-5,.88-6.91.41-3.8.77-7.09-1-10.56-.07-.14-.43-.05-.39.12,1,4,.16,8.41-.44,12.48-.14,1-.45,2.49-.56,4.05-.71-1.2-1.53-2.36-2.12-3.47-1.17-2.21-1-5-.91-7.46.05-1.85.32-3.13-.71-4.72-.07-.11-.29,0-.31.09a8,8,0,0,0,0,1.83c0,1-.18,1.91-.24,2.88a26.67,26.67,0,0,0,0,5.36,15.11,15.11,0,0,0,2.08,5.08,23.32,23.32,0,0,1,1.72,3.15,4.4,4.4,0,0,1,.28,1.2,13.76,13.76,0,0,0,3.11-1.95c.79-2,2.11-3.85,2.75-5.79A12.56,12.56,0,0,0,110,313.6Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.75,315.93c.53-4.67-1.18-10.43-2-11.28a3,3,0,0,0-2.27-.63,5.42,5.42,0,0,0-3.1-1.71c-1.67-.25-2.9-.14-3.9.66a7.92,7.92,0,0,1,2.1-.32,3.92,3.92,0,0,1,2.73,1c.32.32.57.71.89,1.05a1.85,1.85,0,0,0,1.16.65c.22,0,.44,0,.65,0a1.7,1.7,0,0,1,1.17.55,4.3,4.3,0,0,1,.73,1.1,14.09,14.09,0,0,1,1.17,3.28,27.79,27.79,0,0,1,.37,3.16,26.48,26.48,0,0,1,.11,3.88Q113.67,316.61,113.75,315.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36,314.37c0-4,1.37-7.27,2.29-8.25.74-.77,1.1-1.28,1.75-2-.78.94-1.07,1.85-.58,3.9a15.26,15.26,0,0,1,.53,6.15A24.55,24.55,0,0,0,104,330.42C99.2,326,97.38,318.09,97.36,314.37Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.35,314.13a15.26,15.26,0,0,0-.53-6.15c-.49-2.05-.2-3,.58-3.9-.5.59-.84,1-1.3,1.55a10.3,10.3,0,0,0-.17,2.39c.06.93.34,1.77.45,2.68.21,1.66-.31,3.26-.5,4.88a19.54,19.54,0,0,0,.85,8.35,7.54,7.54,0,0,0,2,3.52A24.24,24.24,0,0,1,101.35,314.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.66,334.19a14,14,0,0,0,8.24,3.27c5.08.27,8.49-2.16,10.06-5.07s2.48-3.82,3.21-5.93,0-3.7-.16-4.83-.11-2.94-1-4.06-2.79-.93-4.81-1.86-5.63-1.93-8.25-.68-8.68,8.51-9.91,13.75Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.06,331.05a20.7,20.7,0,0,0-10.1.45,17.7,17.7,0,0,0-2.86,1l.15-.25a17.14,17.14,0,0,1,3.42-3.33c2.9-2.37,6.58-5.45,10.4-6,.24,0,.36-.34.05-.36-4-.24-7.68,2-10.7,4.44a24,24,0,0,0-4.32,4.08,21.78,21.78,0,0,1,1.65-3.64,23.87,23.87,0,0,1,5.8-7c.2-.15-.1-.27-.24-.17-2.52,1.73-4.83,3.07-6.49,5.75a24.54,24.54,0,0,0-2.12,4.15l2,4.06s.13.12.39.32l.34-.22a19.48,19.48,0,0,1,2.55-1.15,32.52,32.52,0,0,1,10-1.9C123,331.24,123.23,331.09,123.06,331.05Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,321.63c-.19-1.13-.11-2.94-1-4.06s-2.79-.93-4.81-1.86-5.63-1.93-8.25-.68a8.84,8.84,0,0,0-1.93,1.42,11,11,0,0,1,3.93-1.33c2.31-.21,3.81,1.21,5.93,1.78,1.2.32,2.88.31,4,.86,1.49.77,1.4,3,1.84,4.36a6.21,6.21,0,0,0,.73,1.57C131.33,322.88,131.1,322.2,131,321.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.42,328.17a15.56,15.56,0,0,0-3.26,3.36c-1.19,1.46-2.26,2.8-4.15,3.4-1.25.39-2.32.44-3.35,1.28-.2.17.17,1.22.31,1.2a9.71,9.71,0,0,0,5.68-2.25,9.41,9.41,0,0,0,2.31-2.77C129,330.37,129.8,329.32,130.42,328.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.66,334.19a4.53,4.53,0,0,1,1.56-.08,35.78,35.78,0,0,1,4.27.16,13.63,13.63,0,0,1,9.08,4.1,16.76,16.76,0,0,1,3.4,5.81,7.85,7.85,0,0,1,.45,4.84,3.53,3.53,0,0,1-3.67,2.64c.28,0,.1,1.82-.22,2-.74.5-1.85.32-3.28.81s-5.47,2.63-8.64-3.69-7.78-14.44-7.78-14.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65,336a22.42,22.42,0,0,0-6.23-.81l-2.59,1.18,1,1.72h0a11.63,11.63,0,0,1,4.18,1,14.19,14.19,0,0,1,5.4,5.28c0,.1.34,0,.28-.12a15.51,15.51,0,0,0-5.29-6.65,8,8,0,0,0-1.76-.82,23.08,23.08,0,0,1,3.55.3,16.56,16.56,0,0,1,9.67,6.13c.07.09.33,0,.28-.12A14.6,14.6,0,0,0,113.65,336Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,344.18a16.76,16.76,0,0,0-3.4-5.81,13.63,13.63,0,0,0-9.08-4.1c-.56,0-1.13-.09-1.7-.12,3,.71,5.12,1.16,7.68,2.83a25.83,25.83,0,0,1,2.22,2,12,12,0,0,1,2.69,4,12.33,12.33,0,0,1,1.08,3.89,6.36,6.36,0,0,1-.55,3.07,3.45,3.45,0,0,1-2.16,1.77,3.53,3.53,0,0,0,3.67-2.64A7.85,7.85,0,0,0,128,344.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76,352.72c1.88,1.44,4,.78,6,.6s4,.67,4.72.38c-.74.5-1.85.32-3.28.81C120,354.93,116.7,356.65,113.76,352.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36,328.48s.79-1.08,2.83-.23,3.36,4.61,2.59,6.5a3.81,3.81,0,0,1-4.83,2.33C102.83,336.34,102.32,330.4,104.36,328.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.12,335.85a12.06,12.06,0,0,1-1.38.41l-.15,0c-1.38-.58-.7-1.15-1-2a9.7,9.7,0,0,1-.89-1.76,9.09,9.09,0,0,1,.18-2.91c.23-1,.66-1.25,1.36-1.35-2-.85-2.83.23-2.83.23a3.85,3.85,0,0,0-.27.3,5.93,5.93,0,0,0,0,2.34,10.47,10.47,0,0,0,.14,2.44,2.48,2.48,0,0,0,.22.47.88.88,0,0,0-.54.66,3.61,3.61,0,0,0,0,1.35,2.17,2.17,0,0,0,1.09,1A3.68,3.68,0,0,0,109.12,335.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83,336.38c2.64.56,5.2,4.33,6.31,6.93a20.33,20.33,0,0,1,1.43,8.85c-.17,3-2.06,3.25-2.06,3.25s-.23,2.57-1.66,3.78-2.55,2.16-4.36,1.31-3-1.37-5.09-5.17-4.75-5.06-2.79-11.05S104.83,336.38,104.83,336.38Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,336.75a4.19,4.19,0,0,0-1-.37,12.36,12.36,0,0,0-1.26.51l.19.08a5.08,5.08,0,0,1-.19,1.19,10.3,10.3,0,0,1-1.93,3.37A11.61,11.61,0,0,1,97.71,345a7.15,7.15,0,0,1-1.45.51,11,11,0,0,0-.31,1.95c2.45,0,5.22-2.52,6.52-4.14a16.56,16.56,0,0,0,2.62-4.2,13.9,13.9,0,0,1,.71,1.65,19.55,19.55,0,0,1,.89,7.29,26.1,26.1,0,0,1-.3,5c0,.15.29.11.33,0a20.49,20.49,0,0,0,0-13.86,11,11,0,0,1,1.1,1.52c1,1.73,2.25,3.86,2.21,5.93,0,.13.25.05.26-.05.23-2.23-1-4.88-2.08-6.8A11.27,11.27,0,0,0,105.85,336.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57,352.16a20.69,20.69,0,0,0-.32-5,23.52,23.52,0,0,1,0,3.56,4.51,4.51,0,0,1-1.08,2.93c-.67.63-1.58,1-1.91,1.91a11.64,11.64,0,0,1-1,3.06,5.47,5.47,0,0,1-2.72,2.19c1.27.16,2.23-.63,3.38-1.6,1.43-1.21,1.66-3.78,1.66-3.78S112.4,355.15,112.57,352.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,352.56c1.14.95,2.95,1,4.56,3.21s2.49,5.14,5,4.66a2.72,2.72,0,0,1-2.69.07c-1.82-.85-3-1.37-5.09-5.17-.59-1.07-1.22-1.94-1.78-2.77Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.43,332.55a1.9,1.9,0,0,0-.39-2.13s.9-1.14-.13-3.33-5.19-6.56-10.4-6-5.4,4.2-5.33,7.91c.06,3.42-.58,5.57-.08,8.76.4,2.55,1.43,6.1,4.38,7.55s5.27.76,8.35-2.38a14.6,14.6,0,0,0,4.28-7.8A3.46,3.46,0,0,0,104.43,332.55Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.86,326.9c-.17,0-.4.25-.12.3a22.12,22.12,0,0,1,6.64,2.17,8.67,8.67,0,0,1,1.81,1.27,1.43,1.43,0,0,0-.15-.22,2.46,2.46,0,0,0,.35-1.56,19.18,19.18,0,0,0-2-1.08C100.18,326.64,98.29,326.86,95.86,326.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.06,334a3.48,3.48,0,0,0-.63-1.4,1.28,1.28,0,0,0,.08-.18,14.14,14.14,0,0,1-2.82,2.7c-1.82,1.42-4.31,3.29-6.56,3.9-.16,0-.15.23,0,.2C98.54,338.6,102.73,336.85,105.06,334Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,344.08a6,6,0,0,0,1.63,1.21c3,1.46,5.27.76,8.35-2.38a14.6,14.6,0,0,0,4.28-7.8,3.35,3.35,0,0,0-.1-1.37,22.68,22.68,0,0,1-.42,2.34,9,9,0,0,1-1.36,2.67,19.19,19.19,0,0,1-4.47,4.34,8.5,8.5,0,0,1-3.94,1.71A8.26,8.26,0,0,1,90.85,344.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,321.07a6.71,6.71,0,0,0-3.12,1,.61.61,0,0,0-.15.3c0,.2.35.19.42,0s2.17-.25,2.51-.27a15.87,15.87,0,0,1,3.15.24c2.45.31,3.86,1.53,5.6,3.19.81.77,1.54,1.58,2.29,2.28a6.27,6.27,0,0,0-.3-.76C102.88,324.91,98.72,320.53,93.51,321.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,321.07a7.66,7.66,0,0,1,1.35,0,3.85,3.85,0,0,0-3.26,4c-.08,2.51,1.21,4.76.85,7.42s-4.07,7-2.36,10.7a13.07,13.07,0,0,1-2-5.46c-.5-3.19.14-5.34.08-8.76C88.11,325.27,88.3,321.61,93.51,321.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.21,321.2c-.13.11-.6.1-.8.19a3.91,3.91,0,0,0-.65.44,4.76,4.76,0,0,0-1.2,1.21,4.82,4.82,0,0,0-.7,2.8,24,24,0,0,0,.74,4c.85,3.77-2.94,7.66-1.95,11.25,0-3.17,2.5-6.46,2.8-8.63.36-2.66-.93-4.91-.85-7.42a3.83,3.83,0,0,1,2.58-3.85Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.25,365c0-8.08-5.34-16.16-16-22.33-21.36-12.32-56-12.32-77.33,0-10.68,6.17-16,14.25-16,22.33h0v14.88c0,8.08,5.34,16.16,16,22.32,21.35,12.33,56,12.33,77.33,0,10.67-6.16,16-14.24,16-22.32V365Zm-90.7-17.75c9.54-5.5,22.33-8.53,36-8.53s26.49,3,36,8.53c8.62,5,13.37,11.28,13.37,17.75s-4.75,12.76-13.37,17.74c-9.53,5.51-22.33,8.54-36,8.54s-26.48-3-36-8.54c-8.62-5-13.37-11.28-13.37-17.74S277.93,352.18,286.55,347.2Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9,387.27c21.36,12.33,56,12.33,77.33,0s21.36-32.32,0-44.65-56-12.32-77.33,0S262.55,374.94,283.9,387.27ZM273.18,365c0-6.47,4.74-12.77,13.37-17.75,9.53-5.5,22.33-8.53,36-8.53s26.48,3,36,8.53c8.62,5,13.37,11.28,13.37,17.75s-4.75,12.76-13.37,17.74c-9.54,5.51-22.33,8.54-36,8.54s-26.49-3-36-8.54C277.93,377.71,273.18,371.41,273.18,365Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.17,365a14.64,14.64,0,0,0,2.14,7.44c2.17-3.75,6-7.27,11.24-10.3,9.53-5.51,22.33-8.54,36-8.54s26.49,3,36,8.54c5.26,3,9.08,6.55,11.26,10.3A14.81,14.81,0,0,0,372,365c0-6.47-4.75-12.77-13.38-17.75-9.52-5.5-22.32-8.54-36-8.54s-26.49,3-36,8.54C277.92,352.18,273.17,358.48,273.17,365Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.17,365a14.64,14.64,0,0,0,2.14,7.44c2.17-3.75,6-7.27,11.24-10.3,9.53-5.51,22.33-8.54,36-8.54s26.49,3,36,8.54c5.26,3,9.08,6.55,11.26,10.3A14.81,14.81,0,0,0,372,365c0-6.47-4.75-12.77-13.38-17.75-9.52-5.5-22.32-8.54-36-8.54s-26.49,3-36,8.54C277.92,352.18,273.17,358.48,273.17,365Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,353.94c9.53-5.5,22.33-8.54,36-8.54s26.48,3,36,8.54c7.11,4.11,11.58,9.12,12.93,14.38-1.35,5.25-5.82,10.26-12.93,14.37-9.54,5.51-22.33,8.54-36,8.54s-26.49-3-36-8.54c-7.12-4.11-11.59-9.12-12.93-14.37C275,363.06,279.43,358.05,286.55,353.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.68,395.64v14.87a71.61,71.61,0,0,1-25.77-8.36c-10.68-6.16-16-14.24-16-22.32V365a19,19,0,0,1,.65-4.88h0c-2.59,9.61,2.53,19.79,15.36,27.2A71.81,71.81,0,0,0,309.68,395.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.53,396.74a8.47,8.47,0,0,0-3.8-6.65,2.71,2.71,0,0,0-2.7-.28h0l-18.41,10.51h0a2.71,2.71,0,0,0-1.13,2.47,8.48,8.48,0,0,0,3.81,6.65,2.7,2.7,0,0,0,2.71.28h0l18.4-10.5h0A2.67,2.67,0,0,0,285.53,396.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39,399.22a2.67,2.67,0,0,0,1.14-2.48,7,7,0,0,0-.65-2.86l-23.73,13.57a7.19,7.19,0,0,0,2.13,2,2.7,2.7,0,0,0,2.71.28l18.4-10.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,409.39a11,11,0,0,0-4.95-8.65,3.51,3.51,0,0,0-3.46-.39h0l0,0h0l-61,32.6,9.1,16.09,58.93-36.45A3.49,3.49,0,0,0,266.38,409.39Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,449.07l58.93-36.45a3.49,3.49,0,0,0,1.48-3.23,10.39,10.39,0,0,0-1.65-5.25l-63.45,36.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.37,448.59a14.45,14.45,0,0,1-6.49-11.35c0-4.18,3-5.86,6.55-3.76a14.46,14.46,0,0,1,6.49,11.36C207.91,449,205,450.69,201.37,448.59Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.37,448.59a14.45,14.45,0,0,1-6.49-11.35c0-4.18,3-5.86,6.55-3.76a14.46,14.46,0,0,1,6.49,11.36C207.91,449,205,450.69,201.37,448.59Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.09,136.79a2.73,2.73,0,0,1-.41,0l-4.12-.64a2.32,2.32,0,0,1-1.62-1,2.29,2.29,0,0,1-.24-1.9L55,125.57a1.77,1.77,0,0,0-.54-1.59,11.86,11.86,0,0,1-1.23-1.32.67.67,0,0,0-.93-.18l-5.15,3.89a2,2,0,0,1-1.87.36A2,2,0,0,1,44,125.27l-1.4-5.81a4.17,4.17,0,0,1,1-3.56l5.06-5.31a4.06,4.06,0,0,0,.89-2.17,37,37,0,0,1,.42-4.07,1,1,0,0,0-.63-1.1l-3.24-1.14a2.46,2.46,0,0,1-1.43-1.29,2.42,2.42,0,0,1-.08-1.92l3.13-8.48a3.39,3.39,0,0,1,3-2.13l3.92-.06a2.23,2.23,0,0,0,1.62-1c.83-1.4,1.71-2.74,2.63-4a3.67,3.67,0,0,0,.59-2.21l-.74-5.76A4.25,4.25,0,0,1,60,71.84l5.76-5.18a1.92,1.92,0,0,1,3.22.78l1.67,4.47a.5.5,0,0,0,.26.29.55.55,0,0,0,.46,0,20.75,20.75,0,0,1,2.56-1,3.12,3.12,0,0,0,1.64-1.39l3.34-7.52a3.12,3.12,0,0,1,3.2-1.75l4.12.64A2.26,2.26,0,0,1,88.07,64l-2.25,7.61a1.78,1.78,0,0,0,.54,1.59,11,11,0,0,1,1.23,1.31.66.66,0,0,0,.93.19l5.15-3.9A1.87,1.87,0,0,1,96.76,72l1.4,5.8a4.15,4.15,0,0,1-1,3.56l-5.06,5.31a4.13,4.13,0,0,0-.89,2.17,38.94,38.94,0,0,1-.42,4.08,1,1,0,0,0,.62,1.1l3.25,1.14a2.47,2.47,0,0,1,1.51,3.2l-3.13,8.49a3.4,3.4,0,0,1-3,2.12l-3.93.07a2.27,2.27,0,0,0-1.62,1,46.54,46.54,0,0,1-2.62,4,3.62,3.62,0,0,0-.59,2.21l.74,5.76a4.3,4.3,0,0,1-1.28,3.45L75,130.56a1.93,1.93,0,0,1-3.22-.79l-1.67-4.46a.45.45,0,0,0-.26-.29.54.54,0,0,0-.46,0,22.55,22.55,0,0,1-2.56,1,3,3,0,0,0-1.64,1.39L61.88,135A3.15,3.15,0,0,1,59.09,136.79Zm-6.48-16.27a2.54,2.54,0,0,1,2,1,10.21,10.21,0,0,0,1,1.12,3.58,3.58,0,0,1,1.05,3.45l-2.25,7.61a.46.46,0,0,0,0,.4.44.44,0,0,0,.35.21L59,135a1.28,1.28,0,0,0,1.25-.68l3.34-7.53a4.87,4.87,0,0,1,2.74-2.38,18.72,18.72,0,0,0,2.33-1,2.39,2.39,0,0,1,1.94-.09,2.29,2.29,0,0,1,1.29,1.35l1.67,4.46a.38.38,0,0,0,.12.18.49.49,0,0,0,.17-.11L79.57,124a2.53,2.53,0,0,0,.69-1.86l-.74-5.76a5.43,5.43,0,0,1,.92-3.52c.89-1.22,1.74-2.51,2.53-3.85a4.06,4.06,0,0,1,3.17-1.87l3.91-.07a1.59,1.59,0,0,0,1.32-.93l3.13-8.48a.69.69,0,0,0,0-.51.67.67,0,0,0-.38-.34l-3.25-1.14A2.88,2.88,0,0,1,89,92.58a35.1,35.1,0,0,0,.41-3.87,5.8,5.8,0,0,1,1.39-3.35l5.06-5.31a2.34,2.34,0,0,0,.5-1.87h0L95,72.37a.34.34,0,0,0-.07-.16l-.14.09-5.15,3.9a2.47,2.47,0,0,1-3.46-.5,9.26,9.26,0,0,0-1-1.12,3.58,3.58,0,0,1-1.05-3.45l2.25-7.61a.48.48,0,0,0,0-.41.5.5,0,0,0-.35-.21l-4.12-.64a1.3,1.3,0,0,0-1.25.69l-3.34,7.52a4.87,4.87,0,0,1-2.74,2.38,18.72,18.72,0,0,0-2.33,1,2.36,2.36,0,0,1-1.94.09,2.3,2.3,0,0,1-1.29-1.34l-1.67-4.46a.52.52,0,0,0-.11-.19A.78.78,0,0,0,67,68L61.2,73.2a2.47,2.47,0,0,0-.69,1.86l.75,5.76a5.62,5.62,0,0,1-.93,3.52,44.12,44.12,0,0,0-2.53,3.85,4.08,4.08,0,0,1-3.17,1.87l-3.92.06a1.61,1.61,0,0,0-1.31.93l-3.13,8.48a.67.67,0,0,0,.4.86l3.25,1.13a2.9,2.9,0,0,1,1.83,3.11,36.06,36.06,0,0,0-.41,3.88A5.77,5.77,0,0,1,50,111.85l-5.06,5.31a2.34,2.34,0,0,0-.5,1.87l1.4,5.81a.34.34,0,0,0,.07.17l.14-.09,5.15-3.9A2.43,2.43,0,0,1,52.61,120.52Zm12.91-5a7.06,7.06,0,0,1-2.16-.32c-2.56-.79-4.4-3-5.18-6.24-1.71-7.12,2.15-17.64,8.61-23.45C70.39,82.3,74.26,81,77.41,82c2.56.8,4.4,3,5.17,6.24,1.72,7.13-2.14,17.65-8.6,23.46h0C71.17,114.21,68.19,115.55,65.52,115.55Zm9.72-32.06c-2.21,0-4.76,1.18-7.23,3.41C62,92.3,58.38,102,60,108.57c.63,2.61,2,4.31,3.94,4.92,2.52.78,5.75-.37,8.86-3.17,6-5.41,9.63-15.13,8-21.67-.63-2.62-2-4.32-3.94-4.92A5.5,5.5,0,0,0,75.24,83.49Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,117.93a1.63,1.63,0,0,1-.31,0l-3-.46a1.89,1.89,0,0,1-1.28-.83,1.85,1.85,0,0,1-.2-1.51l1.64-5.51a1.14,1.14,0,0,0-.35-1,10.52,10.52,0,0,1-.91-1c-.08-.11-.28-.25-.45-.11l-3.74,2.82a1.5,1.5,0,0,1-2.48-.88l-1-4.22a3.2,3.2,0,0,1,.73-2.72l3.67-3.85a2.8,2.8,0,0,0,.6-1.47,26,26,0,0,1,.32-3,.62.62,0,0,0-.36-.62l-2.35-.82a2,2,0,0,1-1.2-2.53l2.28-6.15a2.61,2.61,0,0,1,2.31-1.64l2.84,0a1.5,1.5,0,0,0,1-.63c.59-1,1.23-2,1.91-2.91a2.58,2.58,0,0,0,.4-1.49l-.54-4.17a3.27,3.27,0,0,1,1-2.64L123,66.81a1.61,1.61,0,0,1,1.47-.42,1.64,1.64,0,0,1,1.11,1l1.21,3.24c.16.14.24.13.31.09A16.09,16.09,0,0,1,129,70a2,2,0,0,0,1.09-.92l2.42-5.45A2.39,2.39,0,0,1,135,62.28l3,.46a1.82,1.82,0,0,1,1.48,2.33l-1.63,5.52a1.13,1.13,0,0,0,.34,1,9.32,9.32,0,0,1,.91,1,.33.33,0,0,0,.46.11l3.73-2.82a1.59,1.59,0,0,1,1.5-.29,1.6,1.6,0,0,1,1,1.17l1,4.22a3.17,3.17,0,0,1-.73,2.72l-3.67,3.85a2.8,2.8,0,0,0-.6,1.47,26.05,26.05,0,0,1-.31,3,.62.62,0,0,0,.35.63l2.36.82a2,2,0,0,1,1.19,2.53l-2.27,6.15a2.63,2.63,0,0,1-2.32,1.64l-2.84,0a1.46,1.46,0,0,0-1,.63c-.59,1-1.24,2-1.91,2.91a2.5,2.5,0,0,0-.41,1.48l.54,4.18a3.29,3.29,0,0,1-1,2.64L130,113.37a1.56,1.56,0,0,1-2.59-.64l-1.21-3.23c-.16-.15-.23-.13-.31-.09a16.3,16.3,0,0,1-1.87.76,2,2,0,0,0-1.09.92l-2.42,5.45A2.45,2.45,0,0,1,118.28,117.93Zm-4.69-12.11a2,2,0,0,1,1.57.78,7,7,0,0,0,.74.79,2.76,2.76,0,0,1,.81,2.67l-1.63,5.51.15.25,3,.46a.78.78,0,0,0,.74-.4l2.42-5.46a3.66,3.66,0,0,1,2.08-1.81,14.3,14.3,0,0,0,1.67-.68,1.86,1.86,0,0,1,1.53-.07,1.81,1.81,0,0,1,1,1.07l1.21,3.23,4.13-3.77a1.67,1.67,0,0,0,.45-1.21l-.54-4.18a4.16,4.16,0,0,1,.7-2.66c.65-.88,1.26-1.82,1.83-2.78a3.11,3.11,0,0,1,2.42-1.43l2.84,0a1,1,0,0,0,.81-.57l2.27-6.15a.28.28,0,0,0,0-.24.3.3,0,0,0-.19-.17l-2.35-.83a2.25,2.25,0,0,1-1.43-2.43,27.29,27.29,0,0,0,.3-2.79,4.39,4.39,0,0,1,1.05-2.52l3.66-3.85a1.56,1.56,0,0,0,.33-1.21h0l-1-4.21L140.52,74a2,2,0,0,1-2.73-.39,6.9,6.9,0,0,0-.73-.79,2.79,2.79,0,0,1-.82-2.67l1.64-5.51,0-.21-.2,0-3-.46a.74.74,0,0,0-.74.4l-2.42,5.46a3.72,3.72,0,0,1-2.08,1.81,13.63,13.63,0,0,0-1.67.68,1.93,1.93,0,0,1-1.54.07,1.8,1.8,0,0,1-1-1.07L124.06,68l-4.14,3.77a1.72,1.72,0,0,0-.45,1.21l.54,4.17a4.13,4.13,0,0,1-.7,2.67c-.64.88-1.25,1.82-1.82,2.78a3.14,3.14,0,0,1-2.43,1.43l-2.84,0a1,1,0,0,0-.81.58l-2.27,6.15a.31.31,0,0,0,0,.24.32.32,0,0,0,.19.17l2.35.82a2.26,2.26,0,0,1,1.43,2.43,25.17,25.17,0,0,0-.29,2.79,4.39,4.39,0,0,1-1,2.53l-3.67,3.85a1.6,1.6,0,0,0-.33,1.21l1,4.21,3.64-2.86A1.92,1.92,0,0,1,113.59,105.82Zm9.36-3.29a5.36,5.36,0,0,1-1.61-.24,6,6,0,0,1-3.86-4.63c-1.26-5.22,1.56-12.92,6.28-17.16,2.66-2.38,5.52-3.34,7.86-2.61a5.93,5.93,0,0,1,3.85,4.63c1.26,5.22-1.56,12.92-6.28,17.16h0A9.74,9.74,0,0,1,123,102.53Zm7-23.24a8.11,8.11,0,0,0-5.13,2.43c-4.32,3.88-6.92,10.86-5.79,15.55a4.37,4.37,0,0,0,2.75,3.46c1.77.55,4.06-.28,6.28-2.27h0c4.32-3.88,6.91-10.86,5.78-15.55a4.33,4.33,0,0,0-2.75-3.46A3.88,3.88,0,0,0,130,79.29Z",
    style: {
      fill: "#3A447C"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192,79.5a1.61,1.61,0,0,1-.88-.25,2.45,2.45,0,0,1-1-2.17V54.67a6.47,6.47,0,0,1,2.66-5L225.78,29a2,2,0,0,1,2.2-.19,2.43,2.43,0,0,1,1,2.17V53.35a6.45,6.45,0,0,1-2.66,5l-4.88,3.07-3.29,12.18a1.16,1.16,0,0,1-1,.9,1.15,1.15,0,0,1-1.13-.75l-2.83-7.12L193.36,79.07A2.6,2.6,0,0,1,192,79.5Zm34.25-49.6L193.36,50.59a5.4,5.4,0,0,0-2.17,4.08V77.08a1.42,1.42,0,0,0,.46,1.23,1.18,1.18,0,0,0,1.21-.18l20.72-13,3.27,8.24a.14.14,0,0,0,.16.1.14.14,0,0,0,.14-.12l3.41-12.6,5.22-3.29a5.4,5.4,0,0,0,2.16-4.08V30.94a1.43,1.43,0,0,0-.45-1.23,1.18,1.18,0,0,0-1.21.19Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,56.9a.5.5,0,0,1-.43-.27.57.57,0,0,1,.18-.74l22.65-14.24a.47.47,0,0,1,.68.2.56.56,0,0,1-.18.74L198.49,56.83A.55.55,0,0,1,198.24,56.9Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,61.67a.48.48,0,0,1-.43-.27.57.57,0,0,1,.18-.74l22.65-14.24a.48.48,0,0,1,.68.2.56.56,0,0,1-.18.74L198.49,61.6A.45.45,0,0,1,198.24,61.67Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,66.45a.5.5,0,0,1-.43-.27.57.57,0,0,1,.18-.74L220.64,51.2a.47.47,0,0,1,.68.2.56.56,0,0,1-.18.74L198.49,66.37A.46.46,0,0,1,198.24,66.45Z",
    style: {
      fill: "#3A447C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.56,66.25,329.43,71l3.23,7.26a.69.69,0,0,0,.31.34c.39.22,2.67,1.54,2.79,1.62a.75.75,0,0,0,1.09-.44l3.51-11.87Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,66.25,329.43,71l3.23,7.26a.69.69,0,0,0,.31.34c.39.22,2.67,1.54,2.79,1.62a.75.75,0,0,0,1.09-.44l3.51-11.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.23,72.58l3.23,7.25a.74.74,0,0,0,1.39-.09l3.51-11.87Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,37.06,315.44,56.45a1.7,1.7,0,0,0-.77,1.33V78.56a1.69,1.69,0,0,0,.78,1.33l2.76,1.55a1.76,1.76,0,0,0,1.55,0L353.34,62a1.69,1.69,0,0,0,.77-1.34V39.92a1.66,1.66,0,0,0-.77-1.32l-2.76-1.55A1.73,1.73,0,0,0,349,37.06Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,81V60.2a1.68,1.68,0,0,1,.77-1.33l33.58-19.39c.43-.25.77,0,.77.44V60.7a1.69,1.69,0,0,1-.77,1.34L319.76,81.43C319.33,81.67,319,81.48,319,81Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.76,81.43a1.76,1.76,0,0,1-1.55,0l-2.76-1.55a1.69,1.69,0,0,1-.78-1.33V57.78a1.59,1.59,0,0,1,.25-.79l4.29,2.46a1.51,1.51,0,0,0-.22.75V81C319,81.43,319.3,81.69,319.76,81.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.1,39.78c-.06-.38-.37-.52-.76-.3L319.76,58.87a1.47,1.47,0,0,0-.55.58L314.91,57a1.47,1.47,0,0,1,.54-.54L349,37.05a1.76,1.76,0,0,1,1.55,0l2.76,1.55A1.68,1.68,0,0,1,354.1,39.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.22,68.11a.49.49,0,0,1-.43-.27.58.58,0,0,1,.19-.74l22.65-14.23a.46.46,0,0,1,.67.19.56.56,0,0,1-.18.74L325.47,68A.43.43,0,0,1,325.22,68.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89,279.15l-8.13,4.71,3.23,7.25a.72.72,0,0,0,.31.35l2.79,1.61a.74.74,0,0,0,1.09-.43l3.51-11.88Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,279.15l-8.13,4.71,3.23,7.25a.72.72,0,0,0,.31.35l2.79,1.61a.74.74,0,0,0,1.09-.43l3.51-11.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.69,285.47l3.22,7.26a.75.75,0,0,0,1.4-.09l3.51-11.88Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.48,250,66.9,269.34a1.69,1.69,0,0,0-.77,1.34v20.78a1.66,1.66,0,0,0,.77,1.32l2.76,1.55a1.73,1.73,0,0,0,1.55,0l33.59-19.39a1.7,1.7,0,0,0,.77-1.33V252.82a1.69,1.69,0,0,0-.78-1.33L102,249.94A1.76,1.76,0,0,0,100.48,250Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,293.88V273.1a1.74,1.74,0,0,1,.77-1.34l33.59-19.39c.42-.24.77,0,.77.45V273.6a1.7,1.7,0,0,1-.77,1.33L71.21,294.32C70.79,294.57,70.44,294.37,70.44,293.88Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.21,294.32a1.76,1.76,0,0,1-1.55,0l-2.76-1.55a1.68,1.68,0,0,1-.77-1.32V270.68a1.58,1.58,0,0,1,.24-.79l4.3,2.45a1.56,1.56,0,0,0-.23.76v20.78C70.44,294.33,70.76,294.59,71.21,294.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56,252.68c-.06-.39-.38-.53-.77-.31L71.21,271.76a1.68,1.68,0,0,0-.54.58l-4.3-2.45a1.56,1.56,0,0,1,.53-.55L100.49,250a1.71,1.71,0,0,1,1.54,0l2.76,1.55A1.72,1.72,0,0,1,105.56,252.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.68,281a.5.5,0,0,1-.43-.27.56.56,0,0,1,.18-.74l22.65-14.24a.48.48,0,0,1,.68.2.56.56,0,0,1-.18.74L76.93,280.94A.47.47,0,0,1,76.68,281Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Idea--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.31,97.79a2.95,2.95,0,1,1-2.92-3A2.95,2.95,0,0,1,434.31,97.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.83,97.92c-1.94-1.15-1.92-3,0-4.08a7.81,7.81,0,0,1,7.06.08c1.94,1.14,1.92,3,0,4.07A7.78,7.78,0,0,1,427.83,97.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73,96.85c-2-1.18-2-3.06,0-4.2a8.07,8.07,0,0,1,7.29.08c2,1.18,2,3.06-.05,4.2A8,8,0,0,1,427.73,96.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.63,95.76c-2.06-1.22-2-3.16.05-4.34a8.33,8.33,0,0,1,7.5.08c2.06,1.22,2,3.16-.05,4.34A8.33,8.33,0,0,1,427.63,95.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.53,94.63c-2.13-1.26-2.1-3.26,0-4.47a8.58,8.58,0,0,1,7.74.08c2.12,1.26,2.1,3.26-.05,4.47A8.56,8.56,0,0,1,427.53,94.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.46,93.44c-2.17-1.28-2.14-3.32.05-4.56a8.74,8.74,0,0,1,7.89.09c2.17,1.28,2.15,3.32,0,4.55A8.71,8.71,0,0,1,427.46,93.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.77,59.18a14,14,0,0,0-14.18,13.88c-.12,11.14,9.05,13.08,9,17.57a2.38,2.38,0,0,0,1.39,2,7.55,7.55,0,0,0,6.85.08,2.43,2.43,0,0,0,1.44-2h0c0-4.49,9.25-6.25,9.37-17.38A14,14,0,0,0,431.77,59.18Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.77,59.18a14,14,0,0,0-14.18,13.88c-.12,11.14,9.05,13.08,9,17.57a2.38,2.38,0,0,0,1.39,2,7.55,7.55,0,0,0,6.85.08,2.43,2.43,0,0,0,1.44-2h0c0-4.49,9.25-6.25,9.37-17.38A14,14,0,0,0,431.77,59.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.85,92c-1.41-.84-1.4-2.17,0-3a5.7,5.7,0,0,1,5.15.06c1.41.83,1.4,2.16,0,3A5.7,5.7,0,0,1,428.85,92Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31,90.24a.47.47,0,0,1-.47-.47,34.46,34.46,0,0,1,1.07-8,18.13,18.13,0,0,1,.72-2.22,6,6,0,0,1-1.21-.61,8.28,8.28,0,0,1-1.84-1.58,8.38,8.38,0,0,1-1.88,1.54,5.83,5.83,0,0,1-1.22.58,17.14,17.14,0,0,1,.67,2.24,33.39,33.39,0,0,1,.9,8,.49.49,0,0,1-.49.46.48.48,0,0,1-.46-.49,33.87,33.87,0,0,0-.87-7.78,16.66,16.66,0,0,0-.69-2.23,3,3,0,0,1-2.65-.81,1.52,1.52,0,0,1-.18-2,1.25,1.25,0,0,1,1.3-.53c.75.15,1.47.93,2.09,2.19a5.39,5.39,0,0,0,1.11-.51A7.46,7.46,0,0,0,431,76.57a3.53,3.53,0,0,1-.67-2.68,1.28,1.28,0,0,1,1.29-.94,1.26,1.26,0,0,1,1.27,1,3.51,3.51,0,0,1-.72,2.67,7.36,7.36,0,0,0,1.76,1.55,5.3,5.3,0,0,0,1.1.54c.64-1.25,1.38-2,2.13-2.16a1.29,1.29,0,0,1,1.29.56,1.52,1.52,0,0,1-.22,2,3,3,0,0,1-2.67.75,17.52,17.52,0,0,0-.73,2.22,33.91,33.91,0,0,0-1,7.76.47.47,0,0,1-.47.48Zm-7.56-12.92a.35.35,0,0,0-.28.17c-.23.32,0,.66.13.76a1.89,1.89,0,0,0,1.52.53c-.5-.94-1-1.39-1.3-1.45ZM436,78.87a1.89,1.89,0,0,0,1.53-.49c.09-.1.37-.44.14-.76s-.25-.19-.34-.17C437,77.51,436.53,77.94,436,78.87Zm-4.4-5c-.24,0-.32.1-.36.26a2.25,2.25,0,0,0,.34,1.56,2.33,2.33,0,0,0,.39-1.56A.34.34,0,0,0,431.61,73.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.91,53.83a.66.66,0,0,1-.24,0,.9.9,0,0,1-.91-.92l0-4.77a.92.92,0,0,1,.92-.92.93.93,0,0,1,.91.92l0,4.78A.91.91,0,0,1,431.91,53.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.7,56.52a.91.91,0,0,1-1-.43L418.3,52a.93.93,0,0,1,.34-1.26.92.92,0,0,1,1.25.35l2.37,4.14a.92.92,0,0,1-.34,1.25A.85.85,0,0,1,421.7,56.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,64a.87.87,0,0,1-.7-.09l-4.13-2.4a.93.93,0,0,1-.33-1.26.92.92,0,0,1,1.25-.33l4.13,2.41a.9.9,0,0,1,.33,1.25A.88.88,0,0,1,414.21,64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,74.14a1,1,0,0,1-.25,0l-4.77,0a.92.92,0,1,1,0-1.83l4.78,0a.9.9,0,0,1,.91.92A.91.91,0,0,1,411.44,74.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.57,86.9a1,1,0,0,1-.7-.09l-4.13-2.41a.91.91,0,1,1,.92-1.58l4.13,2.4a.92.92,0,0,1-.22,1.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.77,86.9a1,1,0,0,0,.7-.09l4.12-2.41a.91.91,0,1,0-.92-1.58l-4.13,2.4a.92.92,0,0,0,.23,1.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,74.33a1,1,0,0,1-.25,0l-4.78,0a.92.92,0,0,1-.91-.92.9.9,0,0,1,.92-.91l4.78,0a.91.91,0,0,1,.91.92A.92.92,0,0,1,457,74.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.53,64.1a.92.92,0,0,1-.7-1.68L453,60.05a.92.92,0,0,1,.91,1.59L449.74,64A1,1,0,0,1,449.53,64.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.09,56.61a1,1,0,0,1-.7-.09.94.94,0,0,1-.33-1.26l2.41-4.13a.92.92,0,1,1,1.58.93l-2.4,4.12A.92.92,0,0,1,442.09,56.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.1,91.15c1.61-.27,1.75,2.86,1.87,6.15.1,3,.32,8.88,1,9s2.53-1.24,4.15-1.35,2.84,1.23,1.67,1.83c-.67.35-2.68,1.94-3.63,2.61s-2.19,1.66-2.27,3,7.24,22.55,7.24,22.55,17.12,10.49,20.83,12.52,5.58,1.85,7.63,3.37c-3.92,2.27-9.56,7.86-12.71,10.88,0,0,.73.42-4.3-3.69-6.1-5-17.2-12-20.88-17-2.61-6.44-6.6-24.93-7.18-26.64-.69-2.06-1.69-3.06-2.23-4.72a15.27,15.27,0,0,1-1.18-5.84,2.12,2.12,0,0,1,.68-1.66c.25-.19.57-.28.82-.47.4-.28.73-.83,1.16-1.06.6-.31,1.52.06,2.1-.29.25-.16.76-.92,1-1a5.33,5.33,0,0,1,1.41.07c.28,0,.85.16,1-.21s0-1.44.32-3.84S382,91.34,383.1,91.15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.9,150.47a60.15,60.15,0,0,0-7.27-3.25c-3.51-1.44-21-12.6-21-12.6l-6.36-17.21s-.88,1.78-4.1,2.74a6.39,6.39,0,0,1-5.37-.59s3.84,16.26,4.53,19,1.33,3.82,4,6.24S409,162.93,409,162.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,102.38c-.18,2,.16,4.14-.8,4.76a1.54,1.54,0,0,1-2.22-.78,1.56,1.56,0,0,1-1.06,1.11,1.41,1.41,0,0,1-1.41-.46,1.48,1.48,0,0,1-2.12.36c.26.56,1.16,1.44,2,.55,0,0,1.5.92,2.37-.24,0,0-1.06,1.26-.23,3.62a5.46,5.46,0,0,1,1.07-3.46,2.26,2.26,0,0,0,2.27-.4C382.83,106.52,382,102.38,382,102.38Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458,312.24c-1.89-8.37-1.57-23.5-2.52-31.07-1.12-8.85-7.74-17.62-7.74-17.62s2.8-22.62,3.87-32.7c2.52-23.66-1.89-32.83-4.39-36.39a49.79,49.79,0,0,1-2.71-4.3,37.75,37.75,0,0,1-2.44-5l-32.84.34a42.42,42.42,0,0,0-4.18,18.24c-3.42,12.33-2.85,51.46-2.31,65.62.33,8.48,5.81,45.83,5.93,47,.06.49,1.55,2.64,4.92,2.08s4.27-1.75,4.27-2.1c0-1.23.17-2.59.27-3.81.7-8,3.76-25.06,4.75-33.2a21.07,21.07,0,0,0-2.72-12.85l5-21.9a163.11,163.11,0,0,0,7.23,30.56c3.76,10.74,16.74,42.54,16.74,42.54,1.18,3.34,8.28,1.65,9.2-4.06Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,312.24c1.78-.3,1.53,5.87,2.58,9.61,1.13,4,3.14,6.73,4.1,10a12.36,12.36,0,0,1-.14,8.89c-.86,2.69-6.55,7.22-9.45,4.14s-4-7-4.35-10.89a60,60,0,0,0-1.56-9.67c-.75-3.19-2.43-8.78-1.13-9.2l.75,1.83c1,1.28,9-.4,9.5-3.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,316.62c.45,1.94-.11,7.25-.11,7.25a7.09,7.09,0,0,1-3.86,3l-1.26-7.41Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "415.91 326.88 409.34 324.63 407.82 318.76 415.14 322.34 415.91 326.88"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.82,310.08l-.25-1.74c-.9.42-.85,7.59-5.64,12.63-3.53,3.73-7.55,5.91-9.14,7.86-2.12,2.6,2.86,7,9.41,5.67,3.25-.65,8.18-2.67,9.54-4.84s2.29-5.72,3.4-7.32,4.16-2.82,4.88-4.59c.8-1.95.17-4.6-.36-6.42s-.19-3.46-1-3.5l-.18,1.35c-.45.89-3.07,2.05-6.37,2.19C410.59,311.44,408.52,311.51,407.82,310.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.59,197.28s7.3,5.21,21.41,4.26,20.25-7.08,20.25-7.08a31.22,31.22,0,0,1,5.44,13.27c.76,6-.7,24.44-2.12,37.64s-2,17.74-2,17.74,3.16,5.5,5.46,10.38c3,6.28,2.75,26.79,3.28,34.34-2.7,3.09-8.51,4.34-10.63,3.81-3.18-6.73-13.39-32.73-15-37.66a107,107,0,0,1-6.47-29.38l-4,22a31.74,31.74,0,0,1,2.14,8c.72,4.78-2.91,24.24-4.22,30.32-2.11,1.62-7.23,2.91-12,0-.74-5.64-4.1-26.92-4.58-32.88a292.91,292.91,0,0,1-1-35.41A251.78,251.78,0,0,1,405.59,197.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.16,244.6l-1.87-22.07s-8.91-5.2-11.07-9.93a15.21,15.21,0,0,0,7,11.45l3.05,22.33-1.06,20.24Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.92,135.32a4.7,4.7,0,0,0-.68-1.34,6.17,6.17,0,0,0-1.48-1.11,19.49,19.49,0,0,0-3.3-1.38c-1.93-.68-4-1.59-4.92-3.42a2.32,2.32,0,0,1-.22-1.69,1.19,1.19,0,0,1,1.33-.84,6.41,6.41,0,0,1-1.78-1.89,2.88,2.88,0,0,1-.2-2.52,1.89,1.89,0,0,1,2.13-1.1c-1-1-2.16-2-2.6-3.33a2.78,2.78,0,0,1,.83-3.22c.66-.52,2.64-.56,3.47-.63a54.52,54.52,0,0,0,8.72-1.75,31.1,31.1,0,0,1,10.66-.08c2.9.65,5.49,2,6.77,4.8.33.73.38,1.07,1.1,1.39a13.42,13.42,0,0,1,2.2.87,8.36,8.36,0,0,1,3.21,4.15c.93,2.51.92,5.26,1,7.94s.16,5.45,1.31,7.87c.74,1.57,1.91,3,2.26,4.67a5.18,5.18,0,0,1-7.16,5.79,7.5,7.5,0,0,0,.64-4.28c-.52,2.52-3.08,4.16-5.61,4.66-6.07,1.21-11.57-3.06-14.67-7.91A43.39,43.39,0,0,1,423.92,135.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.6,126.79c.1,0-1.46,4.2-1.64,4.57-1.86,3.77-3.52,7.16-1.79,11.18a8.76,8.76,0,0,0,6.29,4.92,17.15,17.15,0,0,0,4.29.27,5.47,5.47,0,0,0,3.24-1.08c.58-.47.37-2,.39-2.75.09-2.83.18-5.67.26-8.5,0-.51.25-8.29.26-8.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.8,116.94c-2.07,1-6.36,5.43-6.28,16.06.07,8.83,1.6,10.95,4,12,1.42.66,3.75.65,6.47.45l-.11,5.33s-7.91,5.4-1.82,6.76a13.61,13.61,0,0,0,9.71-2,13.25,13.25,0,0,0,3.94-3.6l1-11.86s1.44,1.68,4.34-.41c2.39-1.72,3.44-4.91,1.88-6.82a4,4,0,0,0-6.38.61s-1.52.81-2.82-2.26a40.13,40.13,0,0,1-7.25-4.12A15.42,15.42,0,0,1,421.8,116.94Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.91,137.49l-4.84,1.22a2.45,2.45,0,0,0,3,1.89A2.63,2.63,0,0,0,427.91,137.49Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,140.61a2.3,2.3,0,0,1,2.49-2.08,2.33,2.33,0,0,1,.46.08,2.57,2.57,0,0,1-1.86,2A2.36,2.36,0,0,1,425,140.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.69,126.74l2.64-.7a1.31,1.31,0,0,0-1.63-1A1.42,1.42,0,0,0,417.69,126.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.65,127.31l2.44,1.21a1.31,1.31,0,0,0-.56-1.82A1.44,1.44,0,0,0,429.65,127.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.65 128.37 422.43 135.73 418.49 134.55 423.65 128.37",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,145.49c2.86-.11,9.18-2.27,10.3-4.49a6,6,0,0,1-2.49,3.68c-2.8,1.6-7.84,2.54-7.84,2.54Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.72,131.29l-.43,4.62h0a3.16,3.16,0,0,1-2.85-3.44l.4-4.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.52,129.49a1.27,1.27,0,0,1-1.14,1.33,1.18,1.18,0,0,1-1.3-1.1,1.26,1.26,0,0,1,1.14-1.32A1.18,1.18,0,0,1,419.52,129.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.86,129.86a1.28,1.28,0,0,1-1.15,1.33,1.19,1.19,0,0,1-1.3-1.1,1.26,1.26,0,0,1,1.15-1.32A1.19,1.19,0,0,1,428.86,129.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.1,185.2l4.19-14.52c2.23-6.64,1.56-11.07,1.1-13.16-.76-2.93-9.69-5.56-9.69-5.56-1.36-.43-5.39-.46-6.63-.66l-9.17-.83a42.56,42.56,0,0,0-13.6,11.86c-3,3.89-5.81,9.4.25,15.34a18.35,18.35,0,0,0,.71,7.87",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.87,150.82s-12.6,13-5.54,13.9c7.89,1,14.77-7.25,17.37-12.76,0,0,7,2,8.78,2.57s2.5,6.15,1.08,12.65S442.68,185,442.68,185l4.57,9.51a30.48,30.48,0,0,1-21.73,8.33c-13.79-.22-19.93-5.51-19.93-5.51l2.93-11.88a19.37,19.37,0,0,1-.36-7.59s-3.48-3-3.53-7.31c-.05-4.48,2.27-7.49,6.65-12.24a54.65,54.65,0,0,1,10-7.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39,177.64a9.46,9.46,0,0,1-9.33,4.25,9.94,9.94,0,0,1-8-5.95s-.3,6.94,7.87,7.61S435.39,177.64,435.39,177.64Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M435,214.12v30.8a.64.64,0,0,0,.25.58l1.39.81a.54.54,0,0,0,.22,0,.81.81,0,0,0,.4-.11l34.91-20.16a2,2,0,0,0,.9-1.57V193.76a.65.65,0,0,0-.26-.58l-.06,0h0l-1.3-.77a.6.6,0,0,0-.23-.06.8.8,0,0,0-.4.12L452.48,203l-2.17,1.25-3.24,1.86-.08.05-11.11,6.41a1,1,0,0,0-.18.13,2.12,2.12,0,0,0-.72,1.43Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.25,213.24l1.34.78h0l.13-.2a2.72,2.72,0,0,1,.32-.35l.19-.13,11.1-6.4,3.29-1.89,1.33-.76,19.17-11.06a.63.63,0,0,1,.58-.08l-1.3-.77a.6.6,0,0,0-.23-.06.77.77,0,0,0-.4.12L452.48,203l-2.17,1.25-3.24,1.86-.08.05-11.11,6.41a1,1,0,0,0-.18.13A1.75,1.75,0,0,0,435.25,213.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,193.75l0,30.77a2,2,0,0,1-.91,1.56l-35,20.21a.53.53,0,0,1-.8-.46V214.91a1.77,1.77,0,0,1,.27-.89,1.8,1.8,0,0,1,.64-.67l11.1-6.41,3.29-1.88,20.5-11.83a.65.65,0,0,1,.59-.08l0,0h0A.65.65,0,0,1,473,193.75Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.59,214h0l.13-.2C436.68,213.88,436.64,214,436.59,214Z",
    style: {
      fill: "#3A447C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.66,246.32h0l-1.4-.81a.66.66,0,0,1-.24-.58v-30.8a1.8,1.8,0,0,1,.27-.89l1.35.79h0a1.93,1.93,0,0,0-.26.89v30.92A.52.52,0,0,0,436.66,246.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.23,196c-7.48-30.57-11.33-39.95-20.41-39.83-2.65,3.17.14,13,1.9,17.83,0,0,8,19.63,9.52,26.64,1.32,6.16,2.8,13.91,2.71,19.2a3.88,3.88,0,0,1-1,2.52c-1.71,1.85-1.72,3.34-2.82,5.39-.87,1.6-1.82,2.2-1.55,2.56a2.08,2.08,0,0,0,2.81.2,10.49,10.49,0,0,0,2.13-2,23.92,23.92,0,0,1-1.66,7l-1.9,1.1s.58,2,5.17.66c5.19-1.49,7-2.13,7.59-10.93a67.51,67.51,0,0,0,.1-9.73C466,208.26,465.44,200.93,464.23,196Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.59,153.65s9.17,2,11.36,5.4c2.54,3.89,3.5,8.9,7.77,24.07a131.8,131.8,0,0,1,4.86,34.94s-5.35,2.49-10.28-.35c0,0-2.18-13.2-4.12-20.22S445,175.26,445,175.26,440.13,164.21,443.59,153.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.34,239.5c-.42.26-.6-.53-.7-1.69l0-2.13s-1.63,1.46-2-3.49c-.44-5.44,2-6.44,2-6.44s0-.9,0-2.69.38-2.23.79-2.53l.61-.31v18.9S434.76,239.24,434.34,239.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.34,236.81c0-1.62.15-2.58,1.19-3.22,1.19-.73,1.7-1,1.7-1l.31-10s-1.72,1.16-2.31,1.5-.92-1.7-.89-2.3l-1.41.64-.16,15.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.72,235.84l-1.23.74c-.67.4-1-1.68-.67-4.65l-.28-6.62c.3-3,.35-5.7,1-6.11l1.23-.74Z",
    style: {
      fill: "#37474f"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgileSales);
export default __webpack_public_path__ + "static/media/agile-sales.e8c80cf2a82b24e992a5487c4ffd46d5.svg";
export { ForwardRef as ReactComponent };